import { IProductionStageGroup } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetProductionStageGroupsQuery<D extends IProductionStageGroup[]>(
  params?: HydraQueryParams<D>
) {
  const { vars, options } = params || {};
  return useHydraQuery<D>('productionStageGroups', '/api/production_stage_groups', {
    vars,
    options,
  });
}
